<template>
  <div class="whatsapp-consumptions-reports-container">
    <WhatsappEventsFilters
      ref="filters"
      :events="filteredWhatsappConsumptions"
      @filter-change="onFilterChange"
    />
    <div class="reports-wrap">
      <WhatsappEventsSummary :data="whatsappConsumptionsSummary.data" :loading="whatsappConsumptionsSummary.loading" />
      <div class="whatsapp-api-info">
        <p>{{ $t('WHATSAPP_CONSUMPTIONS_REPORT.INFO.MESSAGE_1') }}</p>
      </div>
      <div class="bar-section full-width">
        <WhatsappEventsCategoryChart :events="whatsappConsumptionsSummary.data" :loading="whatsappConsumptionsSummary.loading" />
      </div>
      <div class="table-section no-bg">
        <h5 class="chart-title">
          {{ $t('WHATSAPP_CONSUMPTIONS_REPORT.CHART.BY_CATEGORY') }}
        </h5>
        <WhatsappEventsReasonsTable :data="whatsappConsumptionsSummary.data" :loading="whatsappConsumptionsSummary.loading"/>
      </div>
      <div class="whatsapp-api-info">
        <p class="margin-0" v-for="keyTranslation in ['TEMPLATES_MARKETING', 'TEMPLATES_UTILITY', 'CONVERSATONS_SERVICE', 'TEMPLATES_AUTHENTICATION', 'MESSAGES_SERVICE']" :key="keyTranslation">
          {{ $t(`WHATSAPP_CONSUMPTIONS_REPORT.INFO.MESSAGE_2.${keyTranslation}`) }}
        </p>
      </div>
      <div class="table-section no-bg table-section-details-messages">
        <woot-tabs :index="whatsappConsumptions.selectedTabIndex" @change="onClickTabChange">
          <woot-tabs-item
            v-for="tab in whatsappConsumptions.tabs"
            :key="tab.key"
            :name="tab.name"
            :show-badge="false"
          />
        </woot-tabs>        
        <woot-button
          v-if="whatsappConsumptions.data.length > 0"
          color-scheme="success"            
          icon="arrow-download"
          size="tiny"
          class="btn-export"
          @click="onExport"
          :isLoading="whatsappConsumptions.exporting"
          :disabled="whatsappConsumptions.exporting"
        >
          {{ $t('WHATSAPP_CONSUMPTIONS_REPORT.TABLE.EXPORT') }}
        </woot-button>
        <WhatsappEventsDetailsTable :events="whatsappConsumptions.data" :loading="whatsappConsumptions.loading" />
        <div class="whatsapp-api-info">
          <p>{{ $t('WHATSAPP_CONSUMPTIONS_REPORT.INFO.MESSAGE_3.TEXT_1') }}:</p>
          <ul>
            <li>{{ $t('WHATSAPP_CONSUMPTIONS_REPORT.INFO.MESSAGE_3.TEXT_2') }}</li>
            <li>{{ $t('WHATSAPP_CONSUMPTIONS_REPORT.INFO.MESSAGE_3.TEXT_3') }}</li>
            <li>{{ $t('WHATSAPP_CONSUMPTIONS_REPORT.INFO.MESSAGE_3.TEXT_4') }}</li>
            <li>{{ $t('WHATSAPP_CONSUMPTIONS_REPORT.INFO.MESSAGE_3.TEXT_5') }}</li>
          </ul>
          <p>{{ $t('WHATSAPP_CONSUMPTIONS_REPORT.INFO.MESSAGE_3.TEXT_6') }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import alertMixin from 'shared/mixins/alertMixin';

import WhatsappEventsDetailsTable from './components/WhatsappEventsDetailsTable';
import WhatsappEventsReasonsTable from './components/WhatsappEventsReasonsTable';
import WhatsappEventsFilters from './components/WhatsappEventsFilters';
import WhatsappConsumptionsApi from '../../../../api/inbox/historyWhatsappConsumptions';
import WhatsappEventsCategoryChart from './components/WhatsappEventsCategoryChart';
import WhatsappEventsSummary from './components/WhatsappEventsSummary';

export default {
  name: 'WhatsappConsumptionsReportsView',
  components: {
    WhatsappEventsFilters,
    WhatsappEventsReasonsTable,
    WhatsappEventsDetailsTable,
    WhatsappEventsCategoryChart,
    WhatsappEventsSummary    
  },
  mixins: [alertMixin],

  data() {
    const today = new Date();
    const sevenDaysAgo = new Date();
    sevenDaysAgo.setDate(today.getDate() - 7);

    return {
      whatsappConsumptions: {
        loading: true,
        data: [],
        exporting: false,
        selectedTabIndex: 0,
        tabs: [
          {
            key: 0,
            name: this.$t('WHATSAPP_CONSUMPTIONS_REPORT.TAB_SEGMENT.TEMPLATE'),
          },
          {
            key: 1,
            name: this.$t('WHATSAPP_CONSUMPTIONS_REPORT.TAB_SEGMENT.CONVERSATION_SERVICE'),
          },
          {
            key: 2,
            name: this.$t('WHATSAPP_CONSUMPTIONS_REPORT.TAB_SEGMENT.CONVERSATION_SERVICE'),
          }
        ]
      },
      filters: {
        customDateRange: [sevenDaysAgo, today],
        inboxes: [],
        users: [],
        messageStatuses: [],
        categories: [],
      },
      whatsappConsumptionsSummary: {
        loading: true,
        data: []
      }
    };
  },
  computed: {
    filteredWhatsappConsumptions() {
      const {
        customDateRange = [],
        inboxes = [],
        users = [],
        messageStatuses = [],
        categories = [],
      } = this.filters;

      const [start, end] = customDateRange;

      return this.whatsappConsumptions.data.filter(item => {
        const createdDate = new Date(item.msg_created_at || item.created_at);
        const createdDateOnly = new Date(
          createdDate.getFullYear(),
          createdDate.getMonth(),
          createdDate.getDate()
        );

        const startDate = start ? new Date(start) : null;
        const endDate = end ? new Date(end) : null;

        const dateMatch =
          !startDate ||
          !endDate ||
          (createdDateOnly >= startDate && createdDateOnly <= endDate);

        const inboxMatch = !inboxes.length || inboxes.includes(item.inbox_name);
        const userMatch = !users.length || users.includes(item.sender_name);
        const statusMatch =
          !messageStatuses.length || messageStatuses.includes(item.status);

        const categoryMatch =
          !categories.length || categories.includes(item.category);

        return (
          dateMatch && inboxMatch && userMatch && statusMatch && categoryMatch
        );
      });
    }    
  },
  mounted() {
    this.$store.dispatch('inboxes/get');
    this.$nextTick(() => {
      this.$refs.filters.emitFilters();
    });
  },
  methods: {
    prepareWhatsappConsumptions(rawMessages) {
      if (!Array.isArray(rawMessages)) return [];

      return rawMessages.map(msg => {
        const statusCode = parseInt(msg.status_code);
        const statusMap = {
          queued: 'queued',
          sent: 'sent',
          delivered: 'delivered',
          failed: 'failed',
          read: 'read',
        };

        const status = statusMap[msg.status_code] || 'unknown';

        const baseUrl = window.location.origin;
        let link_conversation = msg.message_link;

        if (link_conversation.startsWith('/')) {
          link_conversation = `${baseUrl}${link_conversation}`;
        }

        return {
          ...msg,
          status,
          status_message: this.getStatusDescription(statusCode),
          link_conversation,
        };
      });
    },
    getStatusDescription(statusCode) {
      switch (parseInt(statusCode)) {
        case 0:
          return this.$t('WHATSAPP_CONSUMPTIONS_REPORT.STATUS.QUEUED');
        case 1:
          return this.$t('WHATSAPP_CONSUMPTIONS_REPORT.STATUS.SENT');
        case 2:
          return this.$t('WHATSAPP_CONSUMPTIONS_REPORT.STATUS.DELIVERED');
        case 3:
          return this.$t('WHATSAPP_CONSUMPTIONS_REPORT.STATUS.FAILED');
        default:
          return this.$t('WHATSAPP_CONSUMPTIONS_REPORT.STATUS.UNKNOWN');
      }
    },
    onFilterChange(newFilters) {
      this.filters = {
        ...this.filters,
        ...newFilters,
      };
      try {
        this.fetchSummary(this.getFilters());
        this.fetchMessages(this.getMessagesFilters());        
      } catch (error) {
        console.error(
          this.$t('WHATSAPP_CONSUMPTIONS_REPORT.ERRORS.FETCH'),
          error
        );
        this.whatsappConsumptions.data = [];
        
      }
    },
    getFilters(){
      const [start, end] = this.filters.customDateRange || [];
      const formatDate = date => new Date(date).toISOString().split('T')[0];
      const filters = {
        startDate: start ? formatDate(start) : null,
        endDate: end ? formatDate(end) : null,
      }
      if(this.filters.inboxes && this.filters.inboxes.length > 0){
        filters.inboxes = this.filters.inboxes;
      }
      if(this.filters.categories && this.filters.categories.length > 0){
        filters.categories = this.filters.categories;
      }
      return filters;
    },
    getMessagesFilters(){
      const segments = ["template", "conversation_service", "messages_service"]
      return {
        ...this.getFilters(),
        segment: segments[this.whatsappConsumptions.selectedTabIndex]
      }
    },
    fetchSummary(filters){
      this.whatsappConsumptionsSummary.data = [];
      this.whatsappConsumptionsSummary.loading = true;
      WhatsappConsumptionsApi.getSummaryByInbox(filters)
        .then(response => {
          this.whatsappConsumptionsSummary.data = response.data && Array.isArray(response.data) ? response.data : [];
          this.whatsappConsumptionsSummary.loading = false;
        })
        .catch(error => {          
          this.whatsappConsumptionsSummary.loading = false;
          this.showAlert(this.$t('WHATSAPP_CONSUMPTIONS_REPORT.ERRORS.FETCH'));
          
        });
      
    },
    fetchMessages(filters){      
      this.whatsappConsumptions.data = [];
      this.whatsappConsumptions.loading = true;
      WhatsappConsumptionsApi.getAll(filters)
        .then(response => {
          const messages = Array.isArray(response.data)
            ? response.data
            : response.data?.data || [];

          this.whatsappConsumptions.data = this.prepareWhatsappConsumptions(messages);
          this.whatsappConsumptions.loading = false;
        })
        .catch(error => {
          this.whatsappConsumptions.loading = false;
          this.showAlert(this.$t('WHATSAPP_CONSUMPTIONS_REPORT.ERRORS.FETCH'));          
        });
    },    
    onExport() {
      try {
        this.whatsappConsumptions.exporting = true;
        WhatsappConsumptionsApi.export(this.getMessagesFilters())
        .then(response => {          
          this.whatsappConsumptions.exporting = false;
          this.showAlert(this.$t('WHATSAPP_CONSUMPTIONS_REPORT.TABLE.EXPORT_MESSAGE_SUCCESS'));
        })
        .catch(error => {          
          this.whatsappConsumptions.exporting = false;
          this.showAlert(this.$t('WHATSAPP_CONSUMPTIONS_REPORT.ERRORS.EXPORT'));          
        });
      } catch (error) {        
        this.whatsappConsumptions.exporting = false;
        this.showAlert(this.$t('WHATSAPP_CONSUMPTIONS_REPORT.ERRORS.EXPORT'));
      }
    },
    onClickTabChange(index) {
      if(index == this.whatsappConsumptions.selectedTabIndex){
        return;
      }
      this.whatsappConsumptions.selectedTabIndex = index;
      try {
        this.fetchMessages(this.getMessagesFilters());        
      } catch (error) {
        console.error(
          this.$t('WHATSAPP_CONSUMPTIONS_REPORT.ERRORS.FETCH'),
          error
        );
        this.whatsappConsumptions.data = [];        
      }
    },

  },
};
</script>

<style lang="scss" scoped>
.whatsapp-consumptions-reports-container {
  display: flex;
  flex-direction: row;
  width: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
  align-items: flex-start;

  > *:first-child {
    width: 280px;
    flex-shrink: 0;
    margin-right: 24px;
  }

  .reports-wrap {
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    padding: 2vh 2vw 10vh;
    background: #f8fafc;
    overflow: hidden;
    min-width: 0;
    box-sizing: border-box;
  }

  .bar-section, .table-section {
    margin-top: 4vh;
    background: white;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
    box-sizing: border-box;
    width: 100%;
    overflow-x: auto;
  }
  .table-section{

    &.no-bg {
      background: transparent;
      padding: 0;
      box-shadow: none;
    }
    &.table-section-details-messages{
      .btn-export{
        display: inline-block;
        float: right;
        margin: 20px 0;
      }

    }
  }

  .chart-block {
    flex: 1 1 30%;
    min-width: 280px;
    height: 320px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    padding: 0;
    background: transparent;
    border-radius: 0;
    box-shadow: none;
  }

  .chart-block canvas {
    width: 100% !important;
    height: 100% !important;
    max-width: 300px;
    max-height: 300px;
  }

  .bar-section-group {
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    gap: 1rem;
    flex-wrap: nowrap;
  }

  .chart-title {
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 12px;
    display: flex;
    align-content: center;
    align-items: center;
    justify-content: space-between;
  }

  .bar-section.full-width {
    flex: 1 1 100%;
    margin-top: 2vh;
  }

  .bar-section.wide {
    flex: 1 1 70%;
    max-height: 500px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
  }

  .bar-section.narrow {
    flex: 1 1 28%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    overflow: hidden;
  }

  .whatsapp-api-info {
    margin-top: 18px;
    background-color: #e0e0e0;
    color: #222;
    padding: 18px;
    border-radius: 8px;
    font-size: 14px;
    line-height: 1.8;  
  }

  .whatsapp-api-info a {
    color: #4fc3f7;
    text-decoration: underline;
    word-break: break-word;
  }
}
</style>
